<template>
  <Select :value="value" class="adviser-select" :size="size" transfer filterable @on-change="onChange">
    <Option value="all" label="全部运营">全部运营（{{ totalCount }} 人）</Option>
    <Option v-for="item in list" :key="item.id" :value="String(item.id)" :label="item.nickname || '未分配'">
      {{ item.nickname || '未分配' }}（{{ item.count || 0 }} 人）
    </Option>
  </Select>
</template>
<script>
import { API_PREFIX } from './constants'
export default {
  name: 'AdviserSelect',
  props: {
    value: {
      type: String,
      default: 'all'
    },
    size: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      list: []
    }
  },
  computed: {
    totalCount () {
      return this.list.reduce(function (n, item) {
        return n + (item.count || 0)
      }, 0)
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load () {
      let self = this
      self.$http.post(API_PREFIX + '/advisers', {}).then(function (res) {
        if (res && res.status === 'ok') {
          self.list = res.data || []
          self.$emit('on-loaded', self.list)
        }
      })
    },
    onChange (val) {
      let v = val == null || val === '' ? 'all' : String(val)
      if (v === this.value) {
        return
      }
      this.$emit('input', v)
      this.$emit('on-change', v)
    }
  }
}
</script>
<style scoped lang="less">
.adviser-select {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// AdviserSelect.vue?35914ca6